import React from 'react';
import './Homestep.css';
import { MdPerson, MdSchool, MdCardGiftcard, MdAssignment, MdFlight, MdPublic, MdHome, MdAccountBalance } from 'react-icons/md';

const AboutInnovation = () => {
 const items = [
  {
    icon: <MdPerson size={70} color='#DA1313' />,
    title: 'Personalized Counselling',
    points: [
      'We take time to understand your academic history, career ambitions, budget preferences, and personal goals, creating a customized study plan that aligns with your strengths and aspirations for the best possible future abroad.',
    ],
  },
  {
    icon: <MdSchool size={70} color='#DA1313' />,
    title: 'Program & Country Selection',
    points: [
      'We guide you in selecting the most suitable program and destination country by evaluating your academic profile, interests, lifestyle preferences, and career prospects, ensuring the choice perfectly matches your vision and long-term success.',
    ],
  },
  {
    icon: <MdCardGiftcard size={70} color='#DA1313' />,
    title: 'Scholarship Assistance',
  points: [
  'Our team researches and identifies relevant study abroad scholarships, grants, and financial aid opportunities, assisting you with applications, documentation, and submission to help reduce your financial burden while maximizing your funding chances.',
],
  },
  {
    icon: <MdAssignment size={70} color='#DA1313' />,
    title: 'Application Support',
    points: [
      'We assist with completing University application forms, crafting compelling Statements of Purpose, gathering recommendation letters, and preparing for admission interviews, ensuring every detail is polished for a strong and competitive application.',
    ],
  },
  {
    icon: <MdFlight size={70} color='#DA1313' />,
    title: 'Visa Guidance',
    points: [
      'Our experts help you navigate the visa process by preparing necessary documents, guiding you through application steps, and providing interview preparation to ensure a smooth approval and hassle-free transition to your chosen country.',
    ],
  },
  {
    icon: <MdPublic size={70} color='#DA1313' />,
    title: 'Pre-Departure Orientation',
    points: [
      'We prepare you for cultural, academic, and lifestyle adjustments through orientation sessions that cover local customs, transportation, budgeting tips, and essential survival skills to help you confidently start your journey abroad.',
    ],
  },
  {
    icon: <MdHome size={70} color='#DA1313' />,
    title: 'Post-Arrival Support',
    points: [
      'From airport pickups to helping you find accommodation, open a bank account, and adjust to your new surroundings, we ensure you feel supported and comfortable during your initial days in a new country.',
    ],
  },
  {
  icon: <MdAccountBalance size={70} color='#DA1313' />,
  title: 'Education Loan Assistance',
  points: [
    'We guide you in securing education loans by connecting you with trusted financial institutions and banks. Our team helps you understand eligibility, documentation, and repayment options to ease your financial planning.',
  ],
},

];


  return (
    <section className="innovation-section">
        <h2 className='heading text-dark text-center fw-bold'>Our End-to-End Process</h2>
        <p className='text-center mb-5 text-muted'>When you choose Nova EduBridge, you get complete guidance:</p>
      <div className="timeline-container">
        {items.map((item, index) => (
          <div
            className={`timeline-item ${index === items.length - 1 ? 'no-line' : ''}`}
            key={index}
          >
            <div className="timeline-icon bounce-animation">
              {/* Use React Icon directly */}
              {item.icon}
            </div>
            <div className="timeline-content">
              <h2 className="section-titleee">{item.title}</h2>
              <h3 className="section-subtitle">{item.subtitle}</h3>
              <div className="section-list">
                {item.points.map((point, i) => (
                  <p className='text-muted' key={i} >{point}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutInnovation;
